import { render, staticRenderFns } from "./FeedPostCard.vue?vue&type=template&id=1a1f959d&scoped=true&lang=pug&"
import script from "./FeedPostCard.vue?vue&type=script&lang=js&"
export * from "./FeedPostCard.vue?vue&type=script&lang=js&"
import style0 from "./FeedPostCard.vue?vue&type=style&index=0&id=1a1f959d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1f959d",
  null
  
)

export default component.exports